import {
  SET_GOAL,
  SET_LOADING,
  GET_QUESTIONS_BY_GOAL_TYPE_SUCCESS,
  GET_QUESTIONS_BY_GOAL_TYPE_FAIL,
  GET_SAVINGS_PLAN_SUCCESS,
  GET_SAVINGS_PLAN_FAIL,
  SET_SAVINGS_PLAN_ID,
  SET_PROGRAM_DURATION,
  SET_PROGRAM_COST,
  GET_USER_ACCOUNT_DETAILS,
  GET_USER_ACCOUNT_DETAILS_FAIL,
  SET_USER_ACCOUNT_DETAILS,
  GET_USER_GOALS,
  DELETE_USER_GOAL,
  SET_GOAL_TO_LAUNCH,
  RESET_GOAL_TO_LAUNCH,
  SET_ID,
  RESET_USER_ACCOUNT_DETAILS,
  SET_USER_ACCEPTED_TERMS,
  SUBMIT_USER_ANSWER_SUCCESS,
  SUBMIT_USER_ANSWER_FAIL,
  SET_SAVINGS_PLAN_SUCCESS,
  RESET_SAVINGS_PLAN,
  ADD_OTHER_CUSTODIANS_SUCCESS,
  RESET_CUSTODIANS_SUCCESS,
  ADD_OTHER_CUSTODIANS_FAIL,
  SET_GOAL_TO_LAUNCH_PAYLOAD,
  ADD_CUSTODIAN_TYPE_FAIL,
  ADD_CUSTODIAN_TYPE_SUCCESS,
  GET_NEW_DASHBOARD_INFORMATION_SUCCESS,
  RESET_NEW_DASHBOARD_INFORMATION,
  GET_INDIVIDUAL_FORM_SUCCESS,
  GET_INDIVIDUAL_FORM_FAIL,
  POST_INDIVIDUAL_FORM,
  POST_INDIVIDUAL_FORM_FAIL,
  POST_RIA_FORM,
  POST_RIA_FORM_FAIL,
  POST_JOINT_FORM,
  POST_JOINT_FORM_FAIL,
  GET_CONTACT_INFORMATION,
  GET_CONTACT_INFORMATION_FAIL,
  POST_VERIFICATION_FORM,
  POST_VERIFICATION_FORM_FAIL,
  ESTABLISH_SSO_CONNECTION_SUCCESS,
  RESET_ESTABLISH_SSO_CONNECTION_SUCCESS,
  RESET_ALL_FORM_DATA,
  RESET_VERIFICATION_FORM,
  GET_TRANSFER_GOALS_SUCCESS,
  SET_TRANSFER_GOALS_SUCCESS,
  RESET_TRANSFER_GOALS_SUCCESS,
  GET_ADVISOR_NAME,
  RESET_ADVISOR_NAME,
  SET_GOAL_RENAME,
  GET_ACCOUNT_OVERVIEW_SUCCESS,
  RESET_DASHBOARD_DATA,
  SET_LOGIN_SUCCESS_RESPONSE,
  GET_DOCUMENTS,
  GET_DOCUMENTS_FAIL,
  RESET_QA,
  SET_FIRST_LOGIN,
  RESET_INDIVIDUAL_INFORMATION,
  RESET_JOINT_INFORMATION,
  SIGN_ADVISORY_SUCCESS,
  RESET_RIA_INFORMATION,
  GET_IBKR_DEPOSIT_FUNDS_URL_SUCCESS,
  GET_LIST_OF_ADVISORS_SUCCESS,
  GET_ADVISOR_CLIENT_DETAILS_SUCCESS,
  RESET_CLIENT_SUMMARRY_DATA,
  RESET_ADVISOR_DETAILS_DATA,
  GET_ADVISOR_DETAILS_SUCCESS,
  GET_INDIVIDUAL_ACCOUNT_NOTES_SUCCESS,
  RESET_INDIVIDUAL_ACCOUNT_NOTES,
  SET_ADVISOR_NOTE_SUCCESS,
  GET_INDIVIDUAL_ACCOUNT_DETAILS_SUCCESS,
  GET_INVITE_CLIENT_ADVISOR_LIST_SUCCESS,
  INVITE_CLIENT_SUCCESS,
  GET_LIST_OF_INCOMING_ADVISORS_SUCCESS,
  SET_FILTER_SAVE_CLICK,
  SET_FILTER_CLEAR_CLICK,
  RESET_FILTER_CLICK,
  APPLY_FILTER_CLIENT_LIST_TABLE,
  GET_INCOMING_CLIENT_DETAILS_SUCCESS,
  GET_CUSTODIANS_FILTER_SUCCESS,
  GET_RIAS_FILTER_SUCCESS,
  GET_ADVISORS_FILTER_SUCCESS,
  GET_BENCHMARK_DATA_SUCCESS,
  APPLY_FILTER_INCOMING_CLIENT_LIST_TABLE,
  GET_LIST_OF_FIRM_CLIENTS_SUCCESS,
  GET_RECENTLY_FUNDED_ACCOUNT_REPORT_SUCCESS,
  GET_EDIT_FIRM_CLIENT_DETAILS_SUCCESS,
  RESET_EDIT_CLIENT_FARM,
  GET_RECENTLY_REGISTERED_ACCOUNT_REPORT_SUCCESS,
  DELETE_ADVISOR_PORTAL_USER_SUCCESS,
  GET_COMPANY_LOGO_SUCCESS,
  GET_RIAS_FOR_ADVISOR_SUCCESS,
  GET_ROLES_FOR_ADVISOR_SUCCESS,
  FIRM_ADD_USER_SUCCESSFUL,
  RESET_ADD_ADVISOR_PORTAL_USER,
  GET_LIST_OF_FIRM_CLIENTS_BY_FIRM_ID_SUCCESS,
  RESET_DELETE_ADVISOR_PORTAL_USER_SUCCESS,
  GET_ASSET_UNDER_MANAGEMENT_SUCCESS,
  GET_TOP_CLIENTS_SUCCESS,
  GET_DASHBOARD_RELATIONSHIPS_SUCCESS,
  GET_MASTER_ACCOUNTS_SUCCESS,
  ADD_MASTER_ACCOUNTS_SUCCESS,
  REMOVE_MASTER_ACCOUNTS_SUCCESS,
  RESET_MASTER_ACCOUNTS,
} from "../action-types";

const initialState = {
  hasGoal: false,
  goal: {},
  loading: false,
  error: null,
  steps: [],
  dashboardData: {},
  savingsPlanId: null,
  programDuration: null,
  programCost: null,
  userAccountDetails: null,
  userAccountDetailsError: null,
  setUserAccountDetails: null,
  userGoalDetails: null,
  deleteUserGoalDetails: null,
  setGoalToLaunchDetails: null,
  setIsUserAcceptedTerms: null,
  setId: null,
  userQA: null,
  savingsPlanSuccess: null,
  setGoalToLaunchPayLoad: null,
  addOtherCustodiansSuccess: null,
  addCustodianType: null,
  newDashboardData: null,
  individualInformation: null,
  verificationForm: null,
  riaInformation: null,
  jointInformation: null,
  establishSSOConnection: null,
  transferGoals: null,
  transferGoalSet: null,
  accountOverview: null,
  loginSuccessResponse: null,
  documents: null,
  isFirstLogin: true,
  ibkrDepositFundsUrl: {},
  listOfAdvisors: {
    accounts: [],
  },
  listOfIncomingAdvisors: [],
  advisorClientDetails: {},
  advisorDetails: {},
  incomingClientDetails: {},
  individualAccountNotes: [],
  setAdvisorNote: {},
  individualAccountDetails: {},
  InviteClientAdvisorList: [],
  inviteClient: {},
  filterSaveClickColumnName: null,
  filterClearClickColumnName: null,
  filterDataOnClientTable: [],
  filterDataOnIncomingClientTable: [],
  custodianForFilter: [],
  riasForFilter: [],
  advisorsForFilter: [],
  benchmarkData: [],
  listOfFirmClient: [],
  recentlyFundedAccountReport: {},
  editFirmClienData: {},
  recentlyRegisteredAccount: [],
  deleteAdvisorPortalUser: {},
  companyLogo: null,
  RIAsForAdvisor: [],
  rolesForAdvisor: [],
  addFirmuser: null,
  deleteAdvisorPortalUserState: null,
  getAssetUnderManagement: null,
  topClients: null,
  advisorDashboardRelationships: null,
  masterAccounts: [],
  addMasterAccountWhileEdit: null,
  removeMasterAccountWhileEdit: null,
};

export const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_GOAL: {
      return {
        ...state,
        error: false,
        hasGoal: true,
        goal: action.payload,
      };
    }
    case SET_GOAL_RENAME: {
      const updatedGoal = state.newDashboardData.find(
        (goal) => goal.goalId === action.payload.id
      );
      updatedGoal.goalTitle = action.payload.goalTitle;

      return {
        ...state,
        error: false,
        hasGoal: true,
        newDashboardData: [...state.newDashboardData],
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        error: false,
        loading: action.payload,
      };
    }
    case GET_QUESTIONS_BY_GOAL_TYPE_SUCCESS: {
      return {
        ...state,
        error: false,
        steps: action.payload,
      };
    }
    case GET_QUESTIONS_BY_GOAL_TYPE_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case GET_SAVINGS_PLAN_SUCCESS: {
      return {
        ...state,
        error: false,
        dashboardData: action.payload,
      };
    }
    case GET_SAVINGS_PLAN_FAIL: {
      return {
        ...state,
        loading: false,
        dashboardData: action.payload,
      };
    }
    case SET_SAVINGS_PLAN_ID: {
      return {
        ...state,
        savingsPlanId: action.payload,
      };
    }
    case SET_PROGRAM_COST: {
      return {
        ...state,
        programCost: action.payload,
      };
    }
    case SET_PROGRAM_DURATION: {
      return {
        ...state,
        programDuration: action.payload,
      };
    }
    case GET_USER_ACCOUNT_DETAILS: {
      return {
        ...state,
        error: false,
        userAccountDetails: action.payload,
      };
    }
    case SUBMIT_USER_ANSWER_SUCCESS: {
      return {
        ...state,
        error: false,
        userQA: action.payload,
      };
    }
    case RESET_QA: {
      return {
        ...state,
        userQA: null,
      };
    }
    case SUBMIT_USER_ANSWER_FAIL: {
      return {
        ...state,
        error: false,
        userQA: action.payload,
      };
    }
    case RESET_USER_ACCOUNT_DETAILS: {
      return {
        ...state,
        error: false,
        userAccountDetails: null,
      };
    }
    case GET_USER_ACCOUNT_DETAILS_FAIL: {
      return {
        ...state,
        userAccountDetailsError: action.payload,
        loading: false,
      };
    }
    case SET_USER_ACCOUNT_DETAILS: {
      return {
        ...state,
        error: false,
        setUserAccountDetails: action.payload,
      };
    }
    case GET_USER_GOALS: {
      return {
        ...state,
        error: false,
        loading: false,
        userGoalDetails: action.payload,
      };
    }
    case DELETE_USER_GOAL: {
      return {
        ...state,
        error: false,
        deleteUserGoalDetails: action.payload,
      };
    }
    case SET_GOAL_TO_LAUNCH: {
      return {
        ...state,
        error: false,
        loading: false,
        setGoalToLaunchDetails: action.payload,
      };
    }
    case RESET_GOAL_TO_LAUNCH: {
      return {
        ...state,
        error: false,
        loading: false,
        setGoalToLaunchDetails: null,
      };
    }
    case SET_ID: {
      return {
        ...state,
        error: false,
        loading: false,
        setId: action.payload,
      };
    }
    case SET_USER_ACCEPTED_TERMS: {
      return {
        ...state,
        error: false,
        loading: false,
        setIsUserAcceptedTerms: action.payload,
      };
    }
    case SET_SAVINGS_PLAN_SUCCESS: {
      return {
        ...state,
        error: false,
        savingsPlanSuccess: action.payload,
      };
    }
    case RESET_SAVINGS_PLAN: {
      return {
        ...state,
        error: false,
        savingsPlanSuccess: null,
      };
    }
    case ADD_OTHER_CUSTODIANS_SUCCESS: {
      return {
        ...state,
        error: true,
        loading: false,
        addOtherCustodiansSuccess: action.payload,
      };
    }
    case RESET_CUSTODIANS_SUCCESS: {
      return {
        ...state,
        error: true,
        loading: false,
        addOtherCustodiansSuccess: null,
      };
    }
    case ADD_OTHER_CUSTODIANS_FAIL: {
      return { ...state, error: true, loading: false };
    }
    case SET_GOAL_TO_LAUNCH_PAYLOAD: {
      return {
        ...state,
        error: false,
        loading: true,
        setGoalToLaunchPayLoad: action.payload,
      };
    }
    case ADD_CUSTODIAN_TYPE_FAIL: {
      return { ...state, error: true, loading: false };
    }
    case ADD_CUSTODIAN_TYPE_SUCCESS: {
      return {
        ...state,
        error: false,
        addCustodianType: action.payload,
      };
    }
    case RESET_INDIVIDUAL_INFORMATION: {
      return {
        ...state,
        error: false,
        individualInformation: null,
      };
    }
    case GET_INDIVIDUAL_FORM_FAIL: {
      return { ...state, error: true, loading: false };
    }
    case GET_INDIVIDUAL_FORM_SUCCESS: {
      return {
        ...state,
        error: false,
        individualInformation: action.payload,
      };
    }

    case POST_INDIVIDUAL_FORM: {
      return {
        ...state,
        error: false,
        individualInformation: action.payload,
      };
    }
    case POST_INDIVIDUAL_FORM_FAIL: {
      return { ...state, error: true };
    }

    case POST_RIA_FORM: {
      return {
        ...state,
        error: false,
        riaInformation: action.payload,
      };
    }
    case POST_RIA_FORM_FAIL: {
      return { ...state, error: true };
    }
    case RESET_JOINT_INFORMATION: {
      return {
        ...state,
        error: false,
        jointInformation: null,
      };
    }
    case POST_JOINT_FORM: {
      return {
        ...state,
        error: false,
        jointInformation: action.payload,
      };
    }
    case POST_JOINT_FORM_FAIL: {
      return { ...state, error: true };
    }

    case GET_CONTACT_INFORMATION_FAIL: {
      return { ...state, error: true };
    }
    case GET_CONTACT_INFORMATION: {
      return {
        ...state,
        error: false,
        individualInformation: action.payload,
      };
    }
    case POST_VERIFICATION_FORM: {
      return {
        ...state,
        error: false,
        loading: false,
        verificationForm: action.payload,
      };
    }
    case RESET_VERIFICATION_FORM: {
      return {
        ...state,
        error: false,
        verificationForm: null,
      };
    }
    case POST_VERIFICATION_FORM_FAIL: {
      return { ...state, error: true, loading: false };
    }
    case ESTABLISH_SSO_CONNECTION_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        establishSSOConnection: action.payload,
      };
    }
    case RESET_ESTABLISH_SSO_CONNECTION_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        establishSSOConnection: null,
      };
    }
    case RESET_ALL_FORM_DATA: {
      return {
        ...state,
        error: false,
        loading: false,
        individualInformation: null,
        riaInformation: null,
        jointInformation: null,
      };
    }
    case GET_NEW_DASHBOARD_INFORMATION_SUCCESS: {
      return {
        ...state,
        error: true,
        newDashboardData: action.payload,
      };
    }
    case RESET_NEW_DASHBOARD_INFORMATION: {
      return {
        ...state,
        error: true,
        newDashboardData: null,
      };
    }
    case GET_TRANSFER_GOALS_SUCCESS: {
      return {
        ...state,
        error: true,
        transferGoals: action.payload,
      };
    }
    case SET_TRANSFER_GOALS_SUCCESS: {
      return {
        ...state,
        error: true,
        loading: false,
        transferGoalSet: action.payload,
      };
    }
    case RESET_TRANSFER_GOALS_SUCCESS: {
      return {
        ...state,
        error: true,
        loading: false,
        transferGoalSet: null,
      };
    }
    case GET_ADVISOR_NAME: {
      return {
        ...state,
        error: true,
        loading: false,
        advisorName: action.payload,
      };
    }
    case RESET_ADVISOR_NAME: {
      return {
        ...state,
        error: true,
        loading: false,
        advisorName: null,
      };
    }
    case GET_ACCOUNT_OVERVIEW_SUCCESS: {
      return {
        ...state,
        error: true,
        accountOverview: action.payload,
      };
    }
    case RESET_DASHBOARD_DATA: {
      return {
        ...state,
        error: true,
        dashboardData: null,
      };
    }
    case SET_LOGIN_SUCCESS_RESPONSE: {
      return {
        ...state,
        error: false,
        loginSuccessResponse: action.payload,
      };
    }
    case GET_DOCUMENTS: {
      return {
        ...state,
        error: false,
        documents: action.payload,
      };
    }
    case GET_DOCUMENTS_FAIL: {
      return {
        ...state,
        error: true,
      };
    }
    case SET_FIRST_LOGIN: {
      return {
        ...state,
        error: false,
        isFirstLogin: action.payload,
      };
    }
    case SIGN_ADVISORY_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        userAccountDetails: action.payload,
      };
    }
    case RESET_RIA_INFORMATION: {
      return {
        ...state,
        error: false,
        riaInformation: null,
      };
    }
    case RESET_CLIENT_SUMMARRY_DATA: {
      return {
        ...state,
        error: false,
        advisorClientDetails: null,
      };
    }
    case RESET_ADVISOR_DETAILS_DATA: {
      return {
        ...state,
        error: false,
        advisorDetails: null,
      };
    }
    case GET_IBKR_DEPOSIT_FUNDS_URL_SUCCESS: {
      return {
        ...state,
        error: false,
        ibkrDepositFundsUrl: null,
      };
    }
    case GET_LIST_OF_ADVISORS_SUCCESS: {
      return {
        ...state,
        error: false,
        listOfAdvisors: action.payload,
      };
    }
    case GET_LIST_OF_INCOMING_ADVISORS_SUCCESS: {
      return {
        ...state,
        error: false,
        listOfIncomingAdvisors: action.payload,
      };
    }
    case GET_ADVISOR_CLIENT_DETAILS_SUCCESS: {
      return {
        ...state,
        error: false,
        advisorClientDetails: action.payload,
      };
    }
    case GET_ADVISOR_DETAILS_SUCCESS: {
      return {
        ...state,
        error: false,
        advisorDetails: action.payload,
      };
    }
    case GET_INDIVIDUAL_ACCOUNT_NOTES_SUCCESS: {
      return {
        ...state,
        error: false,
        individualAccountNotes: action.payload,
      };
    }
    case RESET_INDIVIDUAL_ACCOUNT_NOTES: {
      return {
        ...state,
        error: false,
        individualAccountNotes: [],
      };
    }
    case SET_ADVISOR_NOTE_SUCCESS: {
      return {
        ...state,
        error: false,
        setAdvisorNote: action.payload,
      };
    }
    case GET_INDIVIDUAL_ACCOUNT_DETAILS_SUCCESS: {
      return {
        ...state,
        error: false,
        individualAccountDetails: action.payload,
      };
    }
    case GET_INVITE_CLIENT_ADVISOR_LIST_SUCCESS: {
      return {
        ...state,
        error: false,
        InviteClientAdvisorList: action.payload,
      };
    }
    case INVITE_CLIENT_SUCCESS: {
      return {
        ...state,
        error: false,
        inviteClientReducer: action.payload,
      };
    }
    case SET_FILTER_SAVE_CLICK: {
      return {
        ...state,
        error: false,
        filterSaveClickColumnName: action.payload,
      };
    }
    case SET_FILTER_CLEAR_CLICK: {
      return {
        ...state,
        error: false,
        filterClearClickColumnName: action.payload,
      };
    }
    case RESET_FILTER_CLICK: {
      return {
        ...state,
        error: false,
        filterClearClickColumnName: null,
        filterSaveClickColumnName: null,
      };
    }
    case APPLY_FILTER_CLIENT_LIST_TABLE: {
      return {
        ...state,
        error: false,
        filterDataOnClientTable: action.payload,
      };
    }
    case APPLY_FILTER_INCOMING_CLIENT_LIST_TABLE: {
      return {
        ...state,
        error: false,
        filterDataOnIncomingClientTable: action.payload,
      };
    }
    case GET_INCOMING_CLIENT_DETAILS_SUCCESS: {
      return {
        ...state,
        error: false,
        incomingClientDetails: action.payload,
      };
    }
    case GET_CUSTODIANS_FILTER_SUCCESS: {
      return {
        ...state,
        error: false,
        custodianForFilter: action.payload,
      };
    }
    case GET_RIAS_FILTER_SUCCESS: {
      return {
        ...state,
        error: false,
        riasForFilter: action.payload,
      };
    }
    case GET_ADVISORS_FILTER_SUCCESS: {
      return {
        ...state,
        error: false,
        advisorsForFilter: action.payload,
      };
    }
    case GET_BENCHMARK_DATA_SUCCESS: {
      return {
        ...state,
        error: false,
        benchmarkData: action.payload,
      };
    }
    case GET_LIST_OF_FIRM_CLIENTS_SUCCESS: {
      return {
        ...state,
        error: false,
        listOfFirmClient: action.payload,
      };
    }
    case GET_LIST_OF_FIRM_CLIENTS_BY_FIRM_ID_SUCCESS: {
      return {
        ...state,
        error: false,
        listOfFirmClient: action.payload,
      };
    }
    case GET_RECENTLY_FUNDED_ACCOUNT_REPORT_SUCCESS: {
      return {
        ...state,
        error: false,
        recentlyFundedAccountReport: action.payload,
      };
    }
    case GET_EDIT_FIRM_CLIENT_DETAILS_SUCCESS: {
      return {
        ...state,
        error: false,
        editFirmClienData: action.payload,
      };
    }
    case RESET_EDIT_CLIENT_FARM: {
      return {
        ...state,
        error: false,
        editFirmClienData: {},
      };
    }
    case GET_RECENTLY_REGISTERED_ACCOUNT_REPORT_SUCCESS: {
      return {
        ...state,
        error: false,
        recentlyRegisteredAccount: action.payload,
      };
    }
    case DELETE_ADVISOR_PORTAL_USER_SUCCESS: {
      return {
        ...state,
        error: false,
        deleteAdvisorPortalUserState: action.payload,
      };
    }
    case RESET_DELETE_ADVISOR_PORTAL_USER_SUCCESS: {
      return {
        ...state,
        error: false,
        deleteAdvisorPortalUserState: null,
      };
    }
    case GET_COMPANY_LOGO_SUCCESS: {
      return {
        ...state,
        error: false,
        companyLogo: action.payload,
      };
    }
    case GET_RIAS_FOR_ADVISOR_SUCCESS: {
      return {
        ...state,
        error: false,
        RIAsForAdvisor: action.payload,
      };
    }
    case GET_ROLES_FOR_ADVISOR_SUCCESS: {
      return {
        ...state,
        error: false,
        rolesForAdvisor: action.payload,
      };
    }
    case FIRM_ADD_USER_SUCCESSFUL: {
      return {
        ...state,
        error: false,
        addFirmuser: action.payload,
      };
    }
    case RESET_ADD_ADVISOR_PORTAL_USER: {
      return {
        ...state,
        error: false,
        addFirmuser: null,
      };
    }
    case GET_ASSET_UNDER_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        error: false,
        getAssetUnderManagement: action.payload,
      };
    }
    case GET_TOP_CLIENTS_SUCCESS: {
      return {
        ...state,
        error: false,
        topClients: action.payload,
      };
    }
    case GET_DASHBOARD_RELATIONSHIPS_SUCCESS: {
      return {
        ...state,
        error: false,
        advisorDashboardRelationships: action.payload,
      };
    }
    case GET_MASTER_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        error: false,
        masterAccounts: action.payload,
      };
    }
    case RESET_MASTER_ACCOUNTS: {
      return {
        ...state,
        error: false,
        masterAccounts: [],
      };
    }
    case ADD_MASTER_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        error: false,
        addMasterAccountWhileEdit: action.payload,
      };
    }
    case REMOVE_MASTER_ACCOUNTS_SUCCESS: {
      return {
        ...state,
        error: false,
        removeMasterAccountWhileEdit: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
